import React from "react";
import PropTypes from "prop-types";
import Calendar, { Day } from "../components/Calendar/Calendar";
import { toISODate } from "../helpers";

import "./PomCalendar.css";

export const PomCalendar = ({ poms }) => {
  let pomsPerDay = poms.reduce((counter, pom) => {
    const date = toISODate(pom.stop);
    counter[date] || (counter[date] = 0);
    counter[date]++;
    return counter;
  }, {});

  // return <pre>{JSON.stringify(pomsPerDay, null, 2)}</pre>;
  // return <Day date="2018-03-02">test</Day>;
  return (
    <Calendar style={{ width: "100%" }}>
      {Object.keys(pomsPerDay).map(date => (
        <Day key={date} date={date} className={`poms${pomsPerDay[date]}`}>
          <div className={`pomsInCalendar`}>
            <img
              src={pomsPerDay[date] > 8 ? "/goldentomato.png" : "/tomato.png"}
              style={{ width: "1em", marginBottom: "-5px" }}
            />x{pomsPerDay[date]}
          </div>
        </Day>
      ))}
    </Calendar>
  );
};

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
// componentName.propTypes = {};

export default PomCalendar;



// WEBPACK FOOTER //
// ./src/charts/PomCalendar.js